import { Heading } from '@components/rolex-ui/Heading'
import { IconButton } from '@components/rolex-ui/IconButton'
import { Text } from '@components/rolex-ui/Text'
import { Box, KontentImage, Track, breakpoints, useSlider } from '@gassan-ui'
import { cn } from '@lib/cn'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { RolexKeepExploringSliderItem } from '@lib/kontent/models/RolexKeepExploringSliderItem'
import _chunk from 'lodash.chunk'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { FC, Fragment, useRef } from 'react'
import { RolexContainer } from '../Container'
import Indicators from './Indicators'

type Props = {
  items: RolexKeepExploringSliderItem[]
  className?: string
  variant?: 'animated' | 'static'
}

const KeepExploring: FC<Props> = ({ items, className, variant = 'static' }) => {
  const { t } = useTranslation('rolex')
  const isTabletUp = useBreakpoint(breakpoints.small)
  const isDesktop = useBreakpoint(breakpoints.large)
  let chunkSize = 2
  if (isTabletUp) {
    chunkSize = 3
  }
  if (isDesktop) {
    chunkSize = 4
  }

  const chunks = _chunk(items, chunkSize)
  const trackRef = useRef<HTMLDivElement>(null)
  const { onTouchEnd, prev, next, canMoveRight, canMoveLeft, index } = useSlider({
    trackRef,
  })

  return (
    <div className={cn('overflow-hidden', className)}>
      <RolexContainer>
        <Heading variant="headline36" as="h2" className="mb-5">
          {t('keepExploring.title')}
        </Heading>
        <div className="relative mb-10">
          <Track ref={trackRef} onTouchEnd={onTouchEnd}>
            {chunks.map((chunk, key) => (
              <Fragment key={key}>
                <div className="grid min-w-full snap-start grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4">
                  {chunk.map((item, key) => (
                    <Link href={item.url.value} key={key} className="group w-full">
                      <KontentImage
                        className="aspect-[3/2]"
                        alt={item.image.value[0].description}
                        src={item.image.value[0].url}
                      />
                      <div className="relative z-[2] bg-white pt-3 transition-transform duration-150 group-hover:-translate-y-2">
                        <Text variant="body20">{item.title.value}</Text>
                      </div>
                    </Link>
                  ))}
                </div>
                <Box p="0.5rem" />
              </Fragment>
            ))}
          </Track>
          {/* {chunks.length > 1 && ( */}
          <div className="pointer-events-none absolute -left-12 top-1/2 z-[2] hidden w-[calc(100%+96px)] -translate-y-10 justify-between md:flex lg:-left-16 lg:w-[calc(100%+128px)]">
            <IconButton
              variant="light"
              as="button"
              icon="chevron-left"
              className="pointer-events-auto"
              onClick={prev}
              status={!canMoveLeft ? 'disabled' : 'idle'}
            />
            <IconButton
              variant="light"
              as="button"
              icon="chevron-right"
              className="pointer-events-auto"
              onClick={next}
              status={!canMoveRight ? 'disabled' : 'idle'}
            />
          </div>
          {/* )} */}
        </div>
        <Indicators activeIndex={index} variant={variant} count={chunks.length} />
      </RolexContainer>
    </div>
  )
}

export default KeepExploring
